export const SIGN_IN = '/signin'
export const HOME = '/'
export const ACCOUNT = '/account'
export const QUEUE = '/queue'
export const FEED = '/feed'
